import { useNavigate } from 'react-router-dom';
import { useAccount } from 'wagmi';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import './Home.css';

export function Home() {
  const { address, isConnected } = useAccount();
  const navigate = useNavigate();

  const handleGetStarted = () => {
    if (isConnected) {
      navigate('/profile');
    }
  };

  return (
    <div className="home-page">
      <div className="home-hero">
        <div className="hero-icon">📖</div>
        <h1 className="hero-title">₿ook of Secrets</h1>
        <p className="hero-subtitle">
          Write your secrets on Bitcoin. Share them with the world, or keep them locked away.
        </p>
        <p className="hero-description">
          A decentralized app on Citrea testnet where you can create encrypted secret pages
          that others can unlock by paying cBTC or using a password.
        </p>

        {!isConnected ? (
          <div className="connect-wallet-wrapper">
            <ConnectButton />
          </div>
        ) : (
          <button
            className="cta-button"
            onClick={handleGetStarted}
          >
            Go to My Profile
          </button>
        )}

        {isConnected && address && (
          <div className="connected-message">
            <span className="checkmark">✓</span> Connected: {address.substring(0, 6)}...
            {address.substring(38)}
          </div>
        )}
      </div>

      <div className="features-section">
        <h2 className="features-title">How It Works</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">✍️</div>
            <h3>Write Secrets</h3>
            <p>
              Create pages in your personal ₿ook. Each page contains an encrypted secret
              that only you can read.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🔒</div>
            <h3>Set Unlock Conditions</h3>
            <p>
              Choose how others can unlock your secrets: set a cBTC price, a password, or both.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">₿</div>
            <h3>Earn cBTC</h3>
            <p>
              When someone pays to unlock your secret, you receive the cBTC directly to your wallet.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🌐</div>
            <h3>Explore Books</h3>
            <p>
              Discover other users' ₿ooks and unlock their secrets by paying or entering passwords.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🔐</div>
            <h3>On-Chain Storage</h3>
            <p>
              Your secrets are permanently stored on the Citrea blockchain, ensuring they're censorship-resistant and always accessible.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">💰</div>
            <h3>Monetize Secrets</h3>
            <p>
              Turn your knowledge into earnings. Set your own price and earn cBTC when others unlock your valuable content.
            </p>
          </div>
        </div>
      </div>

      <div className="tech-section">
        <h2 className="tech-title">Built on Citrea</h2>
        <p className="tech-description">
          This dApp runs on the Citrea testnet, bringing Bitcoin-native smart contracts to life.
          All secrets are stored on-chain with encrypted content, ensuring permanent and censorship-resistant storage.
        </p>
        <div className="tech-badges">
          <div className="badge">🔗 Citrea Testnet</div>
          <div className="badge">₿ cBTC Payments</div>
          <div className="badge">🔐 Encrypted Storage</div>
        </div>
      </div>
    </div>
  );
}
